var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGrisDesactiver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9,11.4C8.9,12,9,12.5,9.3,13l4-4.4c-0.4-0.2-0.8-0.3-1.3-0.3C10.3,8.3,8.9,9.7,8.9,11.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6,6.2L23.4,2L22,0.7L2.7,22l1.4,1.3l4.2-4.6c6.2,2,12.9-1.2,15.2-7.3C22.7,9.4,21.3,7.6,19.6,6.2z M12,16.6 c-0.6,0-1.1-0.1-1.6-0.3l1.6-1.8c1.7,0,3.1-1.4,3.1-3.1c0-0.1,0-0.2,0-0.2l1.7-1.8c1.2,2.6,0,5.7-2.6,6.9 C13.5,16.5,12.7,16.6,12,16.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4,17.3l2.5-2.7c-1.7-2.3-1.3-5.6,1-7.3C10.6,6,12.9,5.9,14.8,7l2.2-2.4c-1.6-0.7-3.2-1-4.9-1c-5.1,0-9.6,3.1-11.5,7.8 C1.5,13.8,3.2,15.9,5.4,17.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGrisDesactiver);
export default __webpack_public_path__ + "static/media/action_gris_desactiver.10335571.svg";
export { ForwardRef as ReactComponent };